import { CardContent, Stack, Unstable_Grid2 as Grid, Box } from '@mui/material';

import { SegmentFragment } from '@occc/graphql';
import {
  Card,
  CircularProgress,
  InfoField,
  LinearProgress,
  Typography,
} from '@occc-app/design-system';
import { pluralize } from '@occc-app/lib/strings';
import { separateEveryThousandByComma } from '@occc-app/lib/numbers';
import { LoadedData } from '@occc-app/routes/Wallet/types';

type SegmentDetailsCardProps = {
  segmentData: LoadedData<SegmentFragment>;
  isMembershipCountUpdating?: boolean;
};

export const SegmentDetailsCard = ({
  segmentData,
  isMembershipCountUpdating = false,
}: SegmentDetailsCardProps) => {
  const { loading, error, data } = segmentData;

  const renderContent = () => {
    if (error) {
      return (
        <Box p={4}>
          <Typography color='error'>Something went wrong. Please try again.</Typography>
        </Box>
      );
    }

    if (loading && !data) {
      return (
        <Box display='flex' justifyContent='center' alignItems='center' p={3}>
          <CircularProgress />
        </Box>
      );
    }

    if (!data) {
      return (
        <Box p={4}>
          <Typography color='error'>No data. Something went wrong. Please try again.</Typography>
        </Box>
      );
    }

    const { description, membershipCount } = data;

    return (
      <Stack>
        <Typography variant='h6' component='p' mb={3}>
          General Details
        </Typography>

        <Grid container spacing={3}>
          <Grid xs={12} sm={4}>
            <InfoField label='Description' value={description} />
          </Grid>

          <Grid xs={12} sm={4}>
            <InfoField
              label='Segment Size'
              disableTypography={isMembershipCountUpdating}
              value={
                isMembershipCountUpdating ? (
                  <>
                    <CircularProgress size={12} />
                    &nbsp;Processing...
                  </>
                ) : (
                  `${separateEveryThousandByComma(membershipCount)} ${pluralize(
                    membershipCount,
                    'Member',
                  )}`
                )
              }
            />
          </Grid>
        </Grid>
      </Stack>
    );
  };

  return (
    <Card>
      {loading && <LinearProgress />}
      <CardContent>{renderContent()}</CardContent>
    </Card>
  );
};
